export default __webpack_public_path__ + "locales/si/InfoPanel.json?hash=d26c64f8f47a5d881fb912a66b7c4d43";